module.exports = __webpack_public_path__ + "img/loading.829b71f1.gif";